import { CountUp, CountUpOptions } from 'countup.js'

const countElements = document.querySelectorAll('.counter .number')

const startCountUp = () => {
  countElements.forEach((item) => {
    if (item instanceof HTMLElement) {
      item.classList.add('fired')
      const options = {
        decimalPlaces: item.dataset.countDecimal,
        decimal: ',',
        startVal:
          item.dataset.countStart !== undefined ? item.dataset.countStart : 0,
        prefix:
          item.dataset.countPrefix !== undefined
            ? item.dataset.countPrefix
            : '',
        suffix:
          item.dataset.countSuffix !== undefined
            ? item.dataset.countSuffix
            : '',
        duration:
          item.dataset.countDuration !== undefined
            ? item.dataset.countDuration
            : 2,
        separator: item.dataset.countSeperator !== undefined ? '.' : '',
      }
      const element = new CountUp(
        item,
        item.dataset.countStop as unknown as number,
        options as CountUpOptions
      )

      if (!element.error) {
        element.start()
      } else {
        console.error(element.error)
      }
    }
  })
}

function revealCountup() {
  for (var i = 0; i < countElements.length; i++) {
    var windowHeight = window.innerHeight
    var elementTop = countElements[i].getBoundingClientRect().top
    var elementVisible = 150

    if (elementTop < windowHeight - elementVisible) {
      if (!countElements[i].classList.contains('fired')) {
        startCountUp()
      }
    }
  }
}

window.addEventListener('scroll', revealCountup)
